import GlobalSearchElement from 'pages/Elements/Dashboard/GlobalSearchElement'
import React, { useEffect, useState } from 'react'
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"

const GlobalSearch = () => {
    const [searchPop, setSearchPop] = useState(false)
    const [boxWidth, setBoxWidth] = useState(0)
    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth
            setBoxWidth(viewportWidth * 0.90)
        }
        updateWidth()
        window.addEventListener("resize", updateWidth)
        return () => window.removeEventListener("resize", updateWidth)
    }, [])
    return (
        <>
            <a onClick={() => setSearchPop(true)}>
                <i className="bx bx-search-alt-2 text-white"></i>
                <span className="text-white">&nbsp; Search</span>
            </a>
            <div className={`note-sticky-form ${searchPop ? "d-block" : "d-none"}`}>
                <Draggable handle=".modal-header" cancel=".modal-body">
                    <ResizableBox
                        width={boxWidth}
                        style={{
                            position: "fixed",
                            top: "10%",
                            right: "5%",
                            zIndex: "1055", backgroundColor: "#fff",
                            maxHeight: "fit-content",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <div className="modal-header pe-4">
                            <h5 className="modal-title mt-0">Global Search</h5>
                            <button
                                type="button"
                                onClick={() => {
                                    setSearchPop(false)
                                }}
                                className="btn-modal-close"
                            >
                                <span aria-hidden="true" className="btn-modal-span">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <GlobalSearchElement />

                    </ResizableBox>
                </Draggable>
            </div>
        </>
    )
}

export default GlobalSearch
